import {RETAILER} from "./config";

// Image
import loyaltyCardImg from './assets/images/loyalty-card.png';
import freshgrocerImg from './assets/images/fg-priceplus-front.jpg';
import shopriteCouponImage from './assets/images/shoprite-card-with-engagements.png'
import freshgrocerCouponImage from './assets/images/shoprite-card-with-engagements.png'
import shopriteBarcode from './assets/images/shoprite-card-barcode.png';
import freshgrocerBarcode from './assets/images/freshgrocer_internal_demo_page_back_of_card.png';
import shopriteBackgroundImage from './assets/images/shoprite-hero.jpg'
import freshgrocerBackgroundImage from './assets/images/FreshGrocer-DD-HERO.jpg'
import shopriteDowntimedollarsLogo from './assets/images/downtimedollars-logo-horizontal.png';
import generalDowntimedollarsLogoVertical from './assets/images/dd_top_nav.jpg';
import generalDowntimedollarsLogo from './assets/images/dd_logo.jpg';
import shopriteDowntimedollarsLogoVertical from './assets/images/downtimedollars-logo-loading.png';
import freshgrocerDowntimedollarsLogoVertical from './assets/images/freshgrocer-downtimedollars-logo-loading.png';
import freshgrocerDowntimedollarsLogo from './assets/images/freshgrocer-downtimedollars-logo-horizontal.png';
import shopriteOnboardingEngage from './assets/images/onboarding-engage.svg';
import shopriteOnboardingCard from './assets/images/onboarding-card.svg';
import shopriteOnboardingShop from './assets/images/onboarding-shop.svg';
import freshgrocerOnboardingCard from './assets/images/freshgrocer-onboarding-card.png';
import freshgrocerOnboardingShop from './assets/images/freshgrocer-onboarding-shop.png';
import freshgrocerOnboardingEngage from './assets/images/freshgrocer-onboarding-engage.svg';
import shopriteIconComplete from './assets/images/icon-tier-complete-no-shadow.svg';
import freshgrocerIconComplete from './assets/images/freshgrocer-icon-tier-complete-no-shadow.svg';
import freshgrocerEmptyScreenImage from './assets/images/freshgrocer-touch-phone.png';
import shopriteEmptyScreenImage from './assets/images/touch-phone.png';


const shopriteValues = {
    RETAILER_NAME: process.env.REACT_APP_RETAILER_NAME,
    REATILER_CARD_IMAGE: loyaltyCardImg,
    RETAILER_TWITTER_URL: 'https://twitter.com/intent/tweet?hashtags=DowntimeDollars&original_referer=https%3A%2F%2Fdowntimedollars.shoprite.com&text=I%20spent%20my%20free%20time%20saving%20money%20at%20%40ShopRite%20with%20%23DowntimeDollars!%20Sign%20up%20today%20with%20your%20Price%20Plus%20Club%20account%20at%20ShopRite.com%2FDowntimeDollars&via=ShopRite',
    SSO_TOKEN: 'e0e946cc-f01a-4843-94f3-ca771879c7bc',
    SSO_URL: "https://wfcapi.azurewebsites.net/api/v1/sp/sso",
    SLO_URL: "https://wfcapi.azurewebsites.net/api/v1/sp/slo",
    COUPON_IMAGE: shopriteCouponImage,
    BACK_CARD_IMAGE: shopriteBarcode,
    BACKGROUND_HOME_IMAGE: shopriteBackgroundImage,
    DOWNTIMEDOLLARS_LOGO: shopriteDowntimedollarsLogo,
    DOWNTIMEDOLLARS_LOGO_VERTICAL: shopriteDowntimedollarsLogoVertical,
    ONBOARDING_ENGAGE: shopriteOnboardingEngage,
    ONBOARDING_CARD: shopriteOnboardingCard,
    ONBOARDING_SHOP: shopriteOnboardingShop,
    PROGRESS_COLOR: '#ed1b2e',
    ICON_COMPLETE: shopriteIconComplete,
    EMPTY_SCREEN_IMAGE: shopriteEmptyScreenImage,
    META_OG_URL: process.env.REACT_APP_META_OG_URL
}

const freshgrocerValues = {
    RETAILER_NAME: process.env.REACT_APP_RETAILER_NAME,
    REATILER_CARD_IMAGE: freshgrocerImg,
    RETAILER_TWITTER_URL: 'https://twitter.com/intent/tweet?hashtags=DowntimeDollars&original_referer=https%3A%2F%2Fdowntimedollars.thefreshgrocer.com&text=I%20spent%20my%20free%20time%20saving%20money%20at%20%40TheFreshGrocer%20with%20%23DowntimeDollars!%20Sign%20up%20today%20with%20your%20Price%20Plus%20Club%20account%20at%20TheFreshGrocer.com%2FDowntimeDollars&via=TheFreshGrocer',
    SSO_TOKEN: 'f19d216b-ff78-48fd-a1ff-559f7180a495',
    SSO_URL: "https://wfcapi.azurewebsites.net/api/v1/sp/sso",
    SLO_URL: "https://wfcapi.azurewebsites.net/api/v1/sp/slo",
    COUPON_IMAGE: freshgrocerCouponImage,
    BACK_CARD_IMAGE: freshgrocerBarcode,
    BACKGROUND_HOME_IMAGE: freshgrocerBackgroundImage,
    DOWNTIMEDOLLARS_LOGO: freshgrocerDowntimedollarsLogo,
    DOWNTIMEDOLLARS_LOGO_VERTICAL: freshgrocerDowntimedollarsLogoVertical,
    ONBOARDING_ENGAGE: freshgrocerOnboardingEngage,
    ONBOARDING_CARD: freshgrocerOnboardingCard,
    ONBOARDING_SHOP: freshgrocerOnboardingShop,
    PROGRESS_COLOR: '#508534',
    ICON_COMPLETE: freshgrocerIconComplete,
    EMPTY_SCREEN_IMAGE: freshgrocerEmptyScreenImage,
    META_OG_URL: process.env.REACT_APP_META_OG_URL
}

const generalValues = {
    RETAILER_NAME: process.env.REACT_APP_RETAILER_NAME,
    REATILER_CARD_IMAGE: loyaltyCardImg,
    RETAILER_TWITTER_URL: '',
    SSO_TOKEN: '',
    SSO_URL: "",
    SLO_URL: "",
    COUPON_IMAGE: shopriteCouponImage,
    BACK_CARD_IMAGE: shopriteBarcode,
    BACKGROUND_HOME_IMAGE: shopriteBackgroundImage,
    DOWNTIMEDOLLARS_LOGO: generalDowntimedollarsLogoVertical,
    DOWNTIMEDOLLARS_LOGO_VERTICAL: generalDowntimedollarsLogo,
    ONBOARDING_ENGAGE: shopriteOnboardingEngage,
    ONBOARDING_CARD: shopriteOnboardingCard,
    ONBOARDING_SHOP: shopriteOnboardingShop,
    PROGRESS_COLOR: '#508534',
    ICON_COMPLETE: shopriteIconComplete,
    EMPTY_SCREEN_IMAGE: shopriteEmptyScreenImage,
    META_OG_URL: process.env.REACT_APP_META_OG_URL
};

const retailers = {
    shoprite: shopriteValues,
    freshgrocer: freshgrocerValues,
    general: generalValues,
    // Add additional retailers here
};


const VALUES = () => {
    const values = retailers[RETAILER];
    if (!values) {
        throw new Error(`Unsupported RETAILER: ${RETAILER}`);
    }
    return values;
};

export const { RETAILER_NAME, REATILER_CARD_IMAGE, RETAILER_TWITTER_URL, SSO_TOKEN, SSO_URL, SLO_URL, COUPON_IMAGE, BACK_CARD_IMAGE, BACKGROUND_HOME_IMAGE, DOWNTIMEDOLLARS_LOGO, DOWNTIMEDOLLARS_LOGO_VERTICAL,
    ONBOARDING_ENGAGE, ONBOARDING_CARD, ONBOARDING_SHOP, PROGRESS_COLOR, ICON_COMPLETE, EMPTY_SCREEN_IMAGE, META_OG_URL}  = VALUES();



// WEBPACK FOOTER //
// ./src/retailerValues.js